let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c9Q8k")).then(() => parcelRequire('cKyEk'));